import {mock} from './index';

export default {
  getRoleList: () => mock('/admin/role/list'),
  createRole: () => mock('/admin/role/create'),
  deleteRole: () => mock('/admin/role/delete'),
  getRoleDetail: () => mock('/admin/role/get'),
  getMenuGroup: () => mock('/admin/role/menuGroup/assignedList'),
  modifyRole: () => mock('/admin/role/modify'),
  getPermissionAssign: () => mock('/admin/role/permission/assignedList'),
  deleteMenuGroup: () => mock('/admin/role/menuGroup/remove'),
  deletePermission: () => mock('/admin/role/permission/remove'),
  getMenuGroupListWithAssigned: () => mock('/admin/role/app/menuGroup/list'),
  getPermissionListWithAssigned: () => mock('/admin/role/app/permission/list'),
  assignMenuGroup: () => mock('/admin/role/menuGroup/assign'),
  assignPermission: () => mock('/admin/role/permission/assign'),
  getStructureAssign: () => mock('/admin/role/structure/assignedList'),
  deleteAvailableStructure: () => mock('/admin/role/structure/remove'),
  getStructureListWithAssigned: () => mock('/admin/role/app/structure/list'),
  assignStructure: () => mock('/admin/role/structure/assign')
};
